<script>
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

/** Pages **/
import Dashboard from '../pages/Dashboard.vue'
import Login from '../pages/Login.vue'
import Event from '../pages/Event.vue'
//import EventTable from '../components/event/EventTable.vue'
import EventCards from '../components/event/EventCards.vue'
import EventShow from '../components/event/EventShow.vue'
import EventEdit from '../components/event/EventEdit.vue'
import EventCreate from '../components/event/EventCreate.vue'
import EventCreateChoices from '../components/event/EventCreateChoices.vue'
import EventCreateFromTemplate from '../components/event/EventCreateFromTemplate'
import EventBank from '../pages/EventBank.vue'
import EventBankMain from '../components/event-bank/Main.vue'
import Tabs from '../components/event-bank/Tabs.vue'
import CategoryTable from '../components/event-bank/CategoryTable.vue'
import Category from '../components/event-bank/Category.vue'
import CategoryEdit from '../components/event-bank/CategoryEdit.vue'
import CategoryCreate from '../components/event-bank/CategoryCreate.vue'
import CategoryImport from '../components/event-bank/CategoryImport.vue'
import ItemTable from '../components/event-bank/ItemTable.vue'
import Item from '../components/event-bank/Item.vue'
import ItemEdit from '../components/event-bank/ItemEdit.vue'
import ItemCreate from '../components/event-bank/ItemCreate.vue'
import ItemImport from '../components/event-bank/ItemImport.vue'
import ItemCopy from '../components/event-bank/ItemCopy.vue'
import Storyboard from '../pages/Storyboard.vue'
import StoryboardIndex from '../components/storyboard/StoryboardIndex.vue'
import StoryboardShow from '../components/storyboard/StoryboardShow.vue'
import StoryboardCreate from '../components/storyboard/StoryboardCreate.vue'
import StoryboardEdit from '../components/storyboard/StoryboardEdit.vue'
import StoryboardPanel from '../components/storyboard/Panel.vue'
import StageShow from '../components/storyboard/StageShow.vue'
import StageCreate from '../components/storyboard/StageCreate.vue'
import StageEdit from '../components/storyboard/StageEdit.vue'
import StepShow from '../components/storyboard/StepShow.vue'
import StepCreate from '../components/storyboard/StepCreate.vue'
import StepEdit from '../components/storyboard/StepEdit.vue'
import StoryboardSearchTabs from '../components/storyboard/SearchTabs.vue'
import StoryboardSearchTable from '../components/storyboard/SearchTable.vue'
import StagePlan from '../components/storyboard/StagePlan.vue'
import StoryboardPlan from '../components/storyboard/StoryboardPlan.vue'
import StoryboardImport from '../components/storyboard/StoryboardImport.vue'
import Script from '../pages/Script.vue'
import ScriptIndex from '../components/script/ScriptIndex.vue'
import ScriptContent from '../components/script/ScriptContent.vue'
import Task from '../pages/Task.vue'
import TaskIndex from '../components/task/TaskIndex.vue'
import TaskContent from '../components/task/TaskContent.vue'
import User from '../pages/User'
import Users from '../pages/Users'
import Companies from '../pages/Companies'
import Company from '../pages/Company'
import ForgotPassword from '../pages/ForgotPassword'
import ResetPassword from '../pages/ResetPassword'
import Budget from '../pages/Budget'

Vue.use(VueRouter)

const isAdmin = (role) => {
  const adminRoles = ['companyadmin', 'systemadmin']
  return adminRoles.includes(role)
}

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/login', component: Login },
    { path: '/forgot', component: ForgotPassword },
    { path: '/resetPassword', component: ResetPassword },
    { path: '/dashboard', component: Dashboard },
    { path: '/', redirect: '/dashboard' },
    { path: '*', redirect: '/' },
    {
      path: '/eventbank',
      component: EventBank,
      children: [
        { path: '', component: EventBankMain },
        { path: 'import', component: ItemImport },
        { path: 'import/categories', component: CategoryImport },
        {
          path: ':type',
          redirect: ':type/items',
          component: Tabs,
          children: [
            { path: 'items', component: ItemTable },
            { path: 'categories', component: CategoryTable },
            { path: 'import', component: ItemImport },
            { path: 'import/categories', component: CategoryImport }
          ]
        },
        { path: ':type/items/new', component: ItemCreate },
        { path: ':type/items/:id', component: Item },
        { path: ':type/categories/new', component: CategoryCreate },
        { path: ':type/categories/:id', component: Category },
        { path: ':type/items/:id/edit', component: ItemEdit },
        { path: ':type/items/:id/copy', component: ItemCopy },
        { path: ':type/categories/:id/edit', component: CategoryEdit }
      ]
    },
    {
      path: '/event',
      component: Event,
      children: [
        { path: '', component: EventCards },
        { path: 'new', component: EventCreate },
        { path: 'new/choices', component: EventCreateChoices },
        { path: 'new/fromTemplate', component: EventCreateFromTemplate },
        { path: ':id', component: EventShow },
        { path: ':id/edit', component: EventEdit }
      ]
    },
    {
      path: '/storyboard',
      component: Storyboard,
      children: [
        { path: '', component: StoryboardIndex },
        { path: 'new', component: StoryboardCreate },
        { path: 'stage/new', component: StageCreate },
        { path: 'step/new', component: StepCreate },
        {
          path: 'search',
          component: StoryboardSearchTabs,
          children: [{ path: ':level', component: StoryboardSearchTable }]
        },
        {
          path: 'import',
          component: StoryboardImport,
          children: [{ path: ':level', component: StoryboardImport }]
        },
        {
          path: ':id',
          component: StoryboardPanel,
          children: [
            { path: '', component: StoryboardShow },
            { path: 'stage/new', component: StageCreate },
            { path: 'stage/:stageId/edit', component: StageEdit },
            { path: 'stage/:stageId/step/new', component: StepCreate },
            { path: 'stage/:stageId', component: StageShow },
            { path: 'stage/:stageId/step/:stepId', component: StepShow },
            { path: 'stage/:stageId/step/:stepId/edit', component: StepEdit },
            { path: 'stage/:stageId/plan', component: StagePlan },
            { path: 'plan', component: StoryboardPlan }
          ]
        },
        { path: ':id/edit', component: StoryboardEdit }
      ]
    },
    {
      path: '/script',
      component: Script,
      children: [
        { path: '', component: ScriptIndex },
        { path: ':type', component: ScriptContent },
        { path: ':type/:id', component: ScriptIndex }
      ]
    },
    {
      path: '/task',
      component: Task,
      children: [
        { path: '', component: TaskIndex },
        { path: ':level', component: TaskContent }
      ]
    },
    {
      path: '/user/:id',
      component: User,
      name: 'user',
      beforeEnter: (to, from, next) => {
        const isUser = store.state.auth.user.id === to.params.id
        const inAdminRole = isAdmin(store.state.auth.user.role)
        if (isUser || inAdminRole) {
          next()
        } else {
          next('/')
        }
      }
    },
    {
      path: '/users',
      component: Users,
      name: 'users',
      beforeEnter: (to, from, next) => {
        const inAdminRole = isAdmin(store.state.auth.user.role)
        if (inAdminRole) {
          next()
        } else {
          next('/')
        }
      }
    },
    {
      path: '/company/:id',
      component: Company,
      name: 'company',
      beforeEnter: (to, from, next) => {
        const isCompanyAdmin = store.state.auth.user.company === to.params.id
        const isSystemAdmin = store.state.auth.user.role === 'systemadmin'
        if (isCompanyAdmin || isSystemAdmin) {
          next()
        } else {
          next('/')
        }
      }
    },
    {
      path: '/companies',
      component: Companies,
      name: 'companies',
      beforeEnter: (to, from, next) => {
        const isSystemAdmin = store.state.auth.user.role === 'systemadmin'
        if (isSystemAdmin) {
          next()
        } else {
          next('/')
        }
      }
    },
    { path: '/budget', component: Budget, name: 'budget' }
  ]
})

// check login state
router.beforeEach((to, from, next) => {
  // if not logged in
  const publicPages = ['/login', '/forgot', '/resetPassword']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStorage.getItem('token')
  if (authRequired && !loggedIn) {
    return next('/login')
  }
  // if no active event
  const noActiveEventNeededPages = ['/event', '/event/new']
  const noActiveEventNeeded = !noActiveEventNeededPages.includes(to.path)
  const hasActiveEvent = store.state.event.activeEvent
  if (!hasActiveEvent && noActiveEventNeeded && loggedIn) {
    return next('/event')
  }

  next()
})

export default router
</script>
